import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import LoadMoreSpinner from "component/common/LoadMoreSpinner";

import "./CustomAlert.scss";
import { detectIsMobileByScreenWidth } from "utils/ScreenUtils";

class CustomAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertStatus: props.status,
    };
  }

  render() {
    const onlyOneButton = !this.props.leftbtn || !this.props.rightbtn
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={
          this.props.customClass
            ? `custom_modal ${this.props.customClass}`
            : "custom_modal"
        }>
        <Modal.Body className="modal_message">
          <div className={`custom-modal-title ${detectIsMobileByScreenWidth() ? "subheading" : "title-medium-1"}`}>
            {this.props?.title || ""}
          </div>
          {this.props.content ? this.props.content :
            <div className={`custom_modal_content ${detectIsMobileByScreenWidth() ? "body-1" : "field-text"}`}>
              {this.props.isLoading ? (
                <div className="loadSpinner_container">
                  <LoadMoreSpinner />
                </div>
              ) : (
                this.props.message
              )}
            </div>}
        </Modal.Body>
        <Modal.Footer
          className={`modal_buttons ${onlyOneButton ? 'only-one-button' : ''}`}
          hidden={this.props.isLoading ? true : false}
        >
          {
            this.props.leftbtn ?
              <button
                onClick={this.props.leftAction}
                className="left_btn button-large"
                hidden={this.props.leftbtn === "" ? true : false}
                disabled={this.props.leftDisabled}
              >
                {this.props.leftbtn}
              </button>
              : null
          }
          {
            this.props.rightbtn ?
              <button onClick={this.props.rightAction} className="right_btn button-large">
                {this.props.rightbtn}
              </button>
              : null
          }

        </Modal.Footer>
      </Modal>
    );
  }
}

export default CustomAlert;
